import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { BadgeCheck, BadgeX } from 'lucide-react';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SubscriptionBadge = ({ token }) => {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    axios.get(`${API_URL}/subscription/status`, { headers: { Authorization: `Bearer ${token}` } })
      .then((res) => setStatus(res.data))
      .catch(() => setStatus(null));
  }, [token]);

  if (!status) return null;
  const paid = status.paid;
  const unpaid = status.vehicles.filter((v) => !v.paid).map((v) => v.registration_number);

  return (
    <div className={`mb-6 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 rounded-2xl border px-4 py-3 ${paid ? 'bg-emerald-50 border-emerald-200 text-emerald-800' : 'bg-red-50 border-red-200 text-red-800'}`} data-testid="subscription-badge">
      <div className="flex items-center gap-2 font-semibold">
        {paid ? <BadgeCheck className="w-5 h-5" /> : <BadgeX className="w-5 h-5" />}
        <span data-testid="subscription-status-text">{paid ? 'Subscription paid this month' : 'Not paid'}</span>
      </div>
      <p className="text-xs sm:text-sm opacity-80">
        {status.vehicles.length === 0
          ? 'No vehicle linked yet.'
          : paid
            ? `Month ${status.month}`
            : `Month ${status.month} · not paid yet: ${unpaid.join(', ')}`}
      </p>
    </div>
  );
};
